import React, { useEffect, useState } from "react";
import GetBlogService from "../../api/Blogs/GetBlogs/GetBlogService";
import axios from "axios";

const DeleteBlogPage = () => {
  const [blogs, setBlogs] = useState<{ _id: string; title: string }[]>([]);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  useEffect(() => {
    GetBlogService().then(setBlogs).catch(console.error);
  }, []);

  const handleSelect = (id: string) => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  const handleBulkDelete = async () => {
    if (selectedIds.length === 0) return alert("No blogs selected!");

    try {
      await axios.post("/api/blogs/delete-multiple", { ids: selectedIds });
      alert("Selected blogs deleted!");
      setBlogs(blogs.filter(blog => !selectedIds.includes(blog._id)));
      setSelectedIds([]);
    } catch (error) {
      console.error(error);
      alert("Failed to delete blogs.");
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Delete Blogs</h2>
      <button
        onClick={handleBulkDelete}
        disabled={selectedIds.length === 0}
        className="mb-4 px-4 py-2 bg-red-600 text-white rounded"
      >
        Delete Selected ({selectedIds.length})
      </button>
      <ul className="space-y-2">
        {blogs.map((blog) => (
          <li key={blog._id} className="flex items-center justify-between border p-2 rounded">
            <label className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={selectedIds.includes(blog._id)}
                onChange={() => handleSelect(blog._id)}
              />
              <span>{blog.title}</span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DeleteBlogPage;
